import { render, staticRenderFns } from "./DropdownAnalysisRoutes.vue?vue&type=template&id=095f0548&scoped=true&"
import script from "./DropdownAnalysisRoutes.vue?vue&type=script&lang=ts&"
export * from "./DropdownAnalysisRoutes.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownAnalysisRoutes.vue?vue&type=style&index=0&id=095f0548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095f0548",
  null
  
)

export default component.exports